export const filter = (data, textInput, fieldName) => {
  if (!textInput || textInput === "") return data;

  return data.filter((user) =>
    user[fieldName].toLowerCase().includes(textInput.toLowerCase())
  );
};
